import React from "react";
import AdIframe from "./AdIframe";
import { pathToRegexp } from "path-to-regexp";
import Cookies from "js-cookie";
import styles from "./AdGlobalPopad.module.less";

type IData = {
  videoUrl?: string;
  des?: string;
  videoLink?: string;
  title: string;
  image: string;
  link?: string;
  video?: string;
  secord: number;
};
interface IProps {
  blacklist: string[];
}

interface IState extends IData {
  closeAd: boolean;
  adslot: string;
  isEmpty: boolean;
}
const AdImageOrVideo = ({ data, onClose }: { data: IData; onClose: any }) => {
  return (
    <div className={styles["AdImageOrVideo"]}>
      <div className={styles["header"]}>
        <div className={styles["left"]}>
          <div className={styles["item-1"]}>
            <img src={`https://photo.8891.com.tw/2024/05/13/1715581544464921.png`} />
          </div>
          <div className={styles["item-2"]}>
            <div className={styles["title"]}>{data.title}</div>
            <div className={styles["desc"]}>{data.des}</div>
          </div>
        </div>
        <div className={styles["right"]}>
          <i className={styles["ad-close-btn"]} onClick={onClose} />
        </div>
      </div>
      <div className={styles["img-video"]}>
        <a href={data.link} target='_blank'>
          {data.video === "" ? <img src={data.image} /> : <video src={data.video} autoPlay={true} muted loop={true} />}
        </a>
      </div>
    </div>
  );
};

class AdGlobalPopad extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      closeAd: false,
      adslot: location.href.includes('c.8891') ? '/173427088/pc-global-popup-ad' : '/173427088/auto-pc-global-popup-ad',
      secord: -1,
      videoUrl: "",
      videoLink: "",
      title: "",
      image: "",
      isEmpty: true,
    };
    this.slotRenderEnded = this.slotRenderEnded.bind(this);
  }
  componentDidMount() {
    const { blacklist } = this.props;

    if (Cookies.get("globalPopupAd") === "2" || blacklist.find((item) => pathToRegexp(item).test(location.pathname))) {
      return;
    } else {
      this.setState({
        closeAd: true,
      });
    }

    let _self = this;
    window.googletag &&
      window.googletag.cmd.push(function () {
        window.googletag.pubads().addEventListener("slotRenderEnded", _self.slotRenderEnded);
      });
  }
  slotRenderEnded(event: any) {
    const { adslot } = this.state;

    let data: any;
    if (event.slot.getAdUnitPath() === adslot) {
      if (Cookies.get("globalPopupAd") === "1") {
        Cookies.set("globalPopupAd", "2");
      } else {
        Cookies.set("globalPopupAd", "1");
      }

      try {
        data = JSON.parse(event.slot.getHtml().split("---")[1]);
        this.countSecond(data.videoUrl ? 15 : 5, data, event.isEmpty);
      } catch (e) {
        this.countSecond(5, undefined, event.isEmpty);
        return;
      }
    }
  }
  countSecond(secord: number, data: any, isEmpty: boolean) {
    let secords = secord;

    this.setState({
      secord: secord,
      isEmpty: isEmpty,
      videoUrl: data !== undefined ? (data.video !== undefined ? data.video : "") : "",
      videoLink: data !== undefined ? (data.link !== undefined ? data.link : "") : "",
      image: data !== undefined ? (data.image === undefined ? "" : data.image) : "",
      des: data !== undefined ? (data.des === undefined ? "" : data.des) : "",
      title: data !== undefined ? data.title : "",
    });

    let secordInterval = setInterval(() => {
      if (secords >= 0) {
        this.setState({
          secord: secords--,
        });
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(secordInterval);
      this.close();
    }, secord * 1000 + 2000);
  }
  close() {
    this.setState({
      closeAd: false,
    });
  }
  render() {
    const { title, des, adslot, secord, videoUrl, videoLink, closeAd, image, isEmpty }: any = this.state;
    const isPotogensis = videoUrl === "" && image === "";

    if (!closeAd) {
      return null;
    }

    return (
      <div className={styles["AdGlobalPopad"]} style={!isEmpty ? { display: "inline-block" } : {}}>
        <AdIframe
          slot={adslot}
          width={["fluid"]}
          height={[400, 225]}
          styles={secord !== -1 && videoUrl == "" && image == "" ? { width: "400px", height: "225px", zIndex: 1 } : {}}
        />
        {!isPotogensis && (
          <AdImageOrVideo
            data={{ secord, link: videoLink, video: videoUrl, image, title, des }}
            onClose={() => this.close()}
          />
        )}
        {!isEmpty && secord !== -1 && videoUrl == "" && image == "" && (
          <>
            <div className={styles["close-btn"]} onClick={() => this.close()}>
              關閉
              <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAGtJREFUGBmFkIEJwCAMBN2oloK1q3QI9+wSdRS9byMoCAbe+P9JiLpSygMONwnp8h1HABnsfZ246eHTIacJXgJ3bzz2jTIuM27yKz4UNIKRgCI1bcgYmqQJ80kYEWTQdtqM/ztB1q+jaPlPFVJOm4h9TOe3AAAAAElFTkSuQmCC' />
            </div>
          </>
        )}
      </div>
    );
  }
}

export default AdGlobalPopad;
